/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthProtocolsCheckPasswordRequest,
  AuthProtocolsCheckPasswordResponse,
  AuthProtocolsCreateClientViewAuthorizationRequest,
  AuthProtocolsCreateClientViewAuthorizationResponse,
  AuthProtocolsGetClientViewClientsResponse,
  AuthProtocolsGetUserInfoResponse,
  AuthProtocolsLoginRequest,
  AuthProtocolsLoginResponse,
  AuthProtocolsLogoutRequest,
  AuthProtocolsLogoutResponse,
  AuthProtocolsOktaLoginInfoRequest,
  AuthProtocolsOktaLoginInfoResponse,
  AuthProtocolsOktaLoginRequest,
  AuthProtocolsOktaLoginResponse,
  AuthProtocolsOktaRiotLoginRequest,
  AuthProtocolsOktaRiotLoginResponse,
  AuthProtocolsOktaSamlLoginRequest,
  AuthProtocolsOktaSamlLoginResponse,
  AuthProtocolsRefreshTokenRequest,
  AuthProtocolsRefreshTokenResponse,
  AuthProtocolsRegisterOtpRequest,
  AuthProtocolsResendVerificationEmailRequest,
  AuthProtocolsVerifyEmailRequest,
  AuthProtocolsVerifyEmailResponse,
  MarqCommonProtocolEmptyRequest,
  MarqCommonProtocolEmptyResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Auth<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Auth
   * @name LoginCreate
   * @request POST:/login
   */
  loginCreate = (data: AuthProtocolsLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsLoginResponse, any>({
      path: `/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name HealthCheckList
   * @request GET:/health_check
   */
  healthCheckList = (params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/health_check`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name CheckPasswordCreate
   * @request POST:/check_password
   */
  checkPasswordCreate = (data: AuthProtocolsCheckPasswordRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsCheckPasswordResponse, any>({
      path: `/check_password`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name LogoutCreate
   * @request POST:/logout
   */
  logoutCreate = (data: AuthProtocolsLogoutRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsLogoutResponse, any>({
      path: `/logout`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RefreshTokenCreate
   * @request POST:/refresh_token
   */
  refreshTokenCreate = (data: AuthProtocolsRefreshTokenRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsRefreshTokenResponse, any>({
      path: `/refresh_token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name OktaCreate
   * @request POST:/login/okta
   */
  oktaCreate = (data: AuthProtocolsOktaRiotLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsOktaRiotLoginResponse, any>({
      path: `/login/okta`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name InfoCreate
   * @request POST:/okta/info
   */
  infoCreate = (data: AuthProtocolsOktaLoginInfoRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsOktaLoginInfoResponse, any>({
      path: `/okta/info`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name LoginCreate2
   * @request POST:/okta/login
   * @originalName loginCreate
   * @duplicate
   */
  loginCreate2 = (data: AuthProtocolsOktaLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsOktaLoginResponse, any>({
      path: `/okta/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name UserInfoList
   * @request GET:/user-info
   */
  userInfoList = (params: RequestParams = {}) =>
    this.http.request<AuthProtocolsGetUserInfoResponse, any>({
      path: `/user-info`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name ClientViewClientsCreate
   * @request POST:/client-view-clients
   */
  clientViewClientsCreate = (data: MarqCommonProtocolEmptyRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsGetClientViewClientsResponse, any>({
      path: `/client-view-clients`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name ClientViewAuthorizationCreate
   * @request POST:/client-view-authorization
   */
  clientViewAuthorizationCreate = (
    data: AuthProtocolsCreateClientViewAuthorizationRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthProtocolsCreateClientViewAuthorizationResponse, any>({
      path: `/client-view-authorization`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name ResendVerificationEmailCreate
   * @request POST:/resend-verification-email
   */
  resendVerificationEmailCreate = (data: AuthProtocolsResendVerificationEmailRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/resend-verification-email`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name VerifyEmailCreate
   * @request POST:/verify-email
   */
  verifyEmailCreate = (data: AuthProtocolsVerifyEmailRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsVerifyEmailResponse, any>({
      path: `/verify-email`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RegisterOtpCreate
   * @request POST:/register-otp
   */
  registerOtpCreate = (data: AuthProtocolsRegisterOtpRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/register-otp`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name SamlLoginCreate
   * @request POST:/okta/saml/login
   */
  samlLoginCreate = (data: AuthProtocolsOktaSamlLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolsOktaSamlLoginResponse, any>({
      path: `/okta/saml/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
